import { render, staticRenderFns } from "./RuleFormDialog.vue?vue&type=template&id=b174ec10&scoped=true"
import script from "./RuleFormDialog.vue?vue&type=script&lang=js"
export * from "./RuleFormDialog.vue?vue&type=script&lang=js"
import style0 from "./RuleFormDialog.vue?vue&type=style&index=0&id=b174ec10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b174ec10",
  null
  
)

export default component.exports